module.exports = __webpack_public_path__ + "static/city-schools-logo-black-5ed6c1ad78a950dc1a133eed9fea5735.png";